import React from 'react';
interface ContainerProps {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  className?: string;
}
export function Container({
  children,
  size = 'lg',
  className = ''
}: ContainerProps) {
  const sizes = {
    sm: 'max-w-3xl',
    md: 'max-w-5xl',
    lg: 'max-w-7xl',
    xl: 'max-w-[1400px]',
    full: 'max-w-full'
  };
  return <div className={`container-modern ${sizes[size]} ${className}`} data-id="element-648">
      {children}
    </div>;
}